import { Model } from "vue-mc";

export class Pais extends Model {
  defaults() {
    return {
      clave: null
      , codigo: ""
      , nombre: ""
      , lada: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , codigo: (codigo) => codigo
      , nombre: (nombre) => nombre
      , lada: (lada) => lada
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/models/geograficos/pais.js